module.exports = __webpack_public_path__ + "static/img/lineweight_view.aef0d920.jpg";